export default __webpack_public_path__ + "static/media/socialIg.fc428e4b.svg";